import moment from "moment";
import LabelText from "../../common/LabelText";
import LetterFooter from "../../components/LetterFooter";
import LetterHeader from "../../components/LetterHeader";
import Table from "../../common/Table";
import addPrecision from "../../common/addPrecision";
import numberFormat from "../../common/numberFormat";
import removeCommas from "../../common/removeCommas";
import { useEffect } from "react";

const header = [
  { title: "Service Description", name: "serviceDescription" },
  { title: "Hours", name: "hours" },
  { title: "Rate", name: "rate" },
  { title: "Amount", name: "amount" },
];

const InvoiceTemplate = ({ data = {}, targetRef }) => {
  console.log(data);
  const noAddress =
    !data?.invoiceAddress || String(data?.invoiceAddress).includes("undefined");

  const details =
    data.detailsTable?.map((i) => {
      return {
        ...i,
        amount: `$ ${addPrecision(numberFormat(i.amount))}`,
      };
    }) || [];

  return (
    <div className="po-request" ref={targetRef}>
      <div style={{ padding: "1cm", paddingTop: 0 }}>
        <div>
          <LetterHeader />
        </div>
        <div
          style={{
            width: "100%",
            backgroundColor: "black",
            margin: "10px 0px",
            color: "white",
            fontWeight: "900",
            padding: 10,
            textAlign: "center",
            letterSpacing: 4,
          }}
        >
          INVOICE
        </div>

        <div>
          <br />
          <div>
            <div className="d-flex" style={{ justifyContent: "space-between" }}>
              <LabelText
                columnMode
                label="INVOICE NO:"
                value={data.invoiceID}
              />
              {data.poNo !== " - " && (
                <LabelText columnMode label="PO NO" value={data.poNo} />
              )}
              <LabelText
                columnMode
                label="TAX REG NO"
                value={"81600 6993 RT 0001"}
              />
            </div>
          </div>
          <br />
          <br />
          <p>Issued on : {moment(data.invoiceDate).format("MMMM DD, YYYY")}</p>
          <div>
            <div className="d-flex">
              <p>Invoice To :</p>
              <p
                style={{
                  maxWidth: 400,
                  paddingLeft: 5,
                  whiteSpace: "pre-line",
                }}
              >
                {!noAddress && `${data.invoiceAddress} \n`}
                {data.poRequestLocation}
              </p>
            </div>
          </div>

          <div className="d-flex">
            <p>Job Date :</p>
            <p
              style={{
                maxWidth: 400,
                paddingLeft: 5,
              }}
            >
              {moment(data.jobStartDate).format("DD/MM/YYYY")} -
              {" " + moment(data.jobEndDate).format("DD/MM/YYYY")}
            </p>
          </div>

          <div className="d-flex">
            <span style={{ paddingRight: 10 }}>Job Location :</span>
            <p className="text-capitalize" style={{ whiteSpace: "pre-line" }}>
              {!Array.isArray(data.location) && data.location}
              {Array.isArray(data.location) &&
                data?.location?.map((i) => `${i?.title}\n`)}
            </p>
          </div>
          <div>
            <br />
            <br />

            <Table header={header} data={details} />
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <div
                style={{
                  display: "flex",
                  width: 300,
                  gap: 10,
                  flexDirection: "column",
                }}
              >
                <LabelText
                  label="SUBTOTAL"
                  labelStyle={{ fontWeight: "500" }}
                  value={`$ ${addPrecision(numberFormat(data.subtotal))}`}
                />
                <LabelText
                  label={`HST  (${data.tax}%)`}
                  value={`$ ${addPrecision(
                    (Number(removeCommas(data.subtotal)) * Number(data.tax)) /
                      100
                  )}`}
                />
                <LabelText
                  label="TOTAL"
                  labelStyle={{ fontWeight: "500" }}
                  value={`$ ${addPrecision(numberFormat(data.total))}`}
                  valueStyle={{ fontWeight: "600" }}
                />
              </div>
            </div>
            <br />
            <br />
          </div>
        </div>
      </div>
      {/* <RequestFooter /> */}
      <LetterFooter />
    </div>
  );
};

export default InvoiceTemplate;
